// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import DotChartOutlinedSvg from "@ant-design/icons-svg/lib/asn/DotChartOutlined";
import AntdIcon from "../components/AntdIcon";
const DotChartOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: DotChartOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    DotChartOutlined.displayName = "DotChartOutlined";
}
export default /*#__PURE__*/ React.forwardRef(DotChartOutlined);
